import { Controller } from 'stimulus';

export default class extends Controller {
  typeSelectTarget!: HTMLSelectElement;
  recurringCheckboxTarget!: HTMLInputElement;
  intervalInputTarget!: HTMLInputElement;
  subscriptionBasedValue!: boolean;

  private selectedRecurringValue: boolean = false;

  static targets = ['typeSelect', 'recurringCheckbox', 'intervalInput'];
  static values = { subscriptionBased: Boolean };

  connect() {
    this.selectedRecurringValue = this.recurringCheckboxTarget.checked;
    this.updateRecurringState();
    this.updateIntervalPlaceholder();
  }

  typeChanged() {
    this.updateRecurringState();
    this.updateIntervalPlaceholder();
  }

  recurringChanged() {
    if (!this.recurringCheckboxTarget.disabled) {
      this.selectedRecurringValue = this.recurringCheckboxTarget.checked;
    }
    this.updateIntervalPlaceholder();
  }

  private updateRecurringState() {
    if (this.typeSelectTarget.value === 'plan') {
      this.recurringCheckboxTarget.disabled = true;
      this.recurringCheckboxTarget.checked = true;
    } else {
      this.recurringCheckboxTarget.disabled = false;
      this.recurringCheckboxTarget.checked = this.selectedRecurringValue;
    }
  }

  private updateIntervalPlaceholder() {
    this.intervalInputTarget.placeholder = this.defaultInterval().toString();
  }

  private defaultInterval(): number {
    if (this.subscriptionBasedValue && this.recurringCheckboxTarget.checked) {
      return 12;
    } else {
      return 1;
    }
  }
}
